var React = require('react');
var PropTypes = React.PropTypes;
var moment = require('moment');
// var Auth = require('../../resources/auth');
var request = require('superagent');
var env = require("../../utils/env");
var Helpers = require("../../utils/helpers");
var StudentRes = require("../../resources/student");
var apiDomain = env.domain.api;
// import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import { Link } from 'react-router';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import createConfirm from '../Modal/createConfirm';
import notification from '../Modal/notification';
import async from 'async';
import $ from 'jquery';

import '../../css/components/Students/students.css';
import '../../css/components/Students/StudentsTable.css';

var SchoolsTable = React.createClass({

    renderHeaderRows: function(ifCreatingClass,ifViewingFromClass) {
        var result = [],
            _this = this;
        
        result.push(<th key={'schoolName'} className="sortable" onClick={this.changeSort.bind(this, 'schoolName')}>
                School Name
                {this.getSortIcon('firstName')}
                </th>);
        // result.push(<th key={'lastName'} className="sortable" onClick={this.changeSort.bind(this, 'lastName')}>
        //         Last Name
        //         {this.getSortIcon('lastName')}
        //         </th>);
        result.push(<th key={'noOfTeachers'} className="sortable" onClick={this.changeSort.bind(this, 'noOfTeachers')}>
                Number of Teachers
                {this.getSortIcon('email')}
                </th>);
        // result.push(<th key={'phone'} className="sortable" onClick={this.changeSort.bind(this, 'phone')}>
        //         Phone
        //         {/*{this.getSortIcon('phone')}*/}
        //         </th>);
        result.push(<th key={'dateCreated'} className="sortable" onClick={this.changeSort.bind(this, 'dateCreated')}>
                Date Created
                {this.getSortIcon('lastActivityDate')}
                </th>);

        if (ifCreatingClass) { //for when creating a new class using this list of students. this is to add a new column for the button which user can click on to add to class

            result.push(<th key={'_id'} className="sortable">
                
                Add Teacher
                
                </th>);
        
        } 
        else {
            if (ifViewingFromClass) { //if view this table from the students list in a specific class

                result.push(<th key={'_id'} className="sortable">
                    Actions
                    </th>);
            } else {
                result.push(<th key={'_id'} className="sortable">
                    Actions
                    </th>);
            }
            // result.push(<th key={'_id' + 'email'} className="sortable">
            //         Analytics
            // </th>);
        }
        // for (var i = 0; i < types.length; i++) {
        //     var type = types[i];
        //     switch(type) {
        //     case 'title':
        //         result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'title')}>
        //         Title
        //         {this.getSortIcon('title')}
        //         </th>);
        //         break;
        //     case 'subject':
        //         result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'metadata.subjectName')}>
        //         <span>
        //             Subject
        //             {this.getSortIcon('metadata.subjectName')}
        //         </span>
        //         </th>);
        //         break;
        //     case 'concept':
        //         result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'metadata.conceptName')}>
        //         <span>
        //             Concept
        //             {this.getSortIcon('metadata.conceptName')}
        //         </span>
        //         </th>);
        //         break;
        //     case 'mcqStat':
        //         result.push(<th key={type}>MCQ</th>);
        //         break;
        //     case 'ssStat':
        //         result.push(<th key={type}>SS</th>);
        //         break;
        //     case 'lsStat':
        //         result.push(<th key={type}>LS</th>);
        //         break;
        //     case 'reviewer':
        //         result.push(<th key={type}>Reviewers</th>);
        //         break;
        //     case 'finishReview':
        //         result.push(<th key={type}>Finished Review</th>);
        //         break;
        //     case 'dateCreated':
        //         result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'dateCreated')}>
        //         Date Created
        //         {this.getSortIcon('dateCreated')}
        //         </th>);
        //         break;
        //     case 'dateModified':
        //         result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'dateModified')}>
        //         Date Updated
        //         {this.getSortIcon('dateModified')}
        //         </th>);
        //         break;
        //     case 'dateSubmitted':
        //         result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'date_submitted')}>
        //         Date Submitted
        //         {this.getSortIcon('date_submitted')}
        //         </th>);
        //         break;
        //     case 'creator':
        //         result.push(<th key={type}>Creator</th>);
        //         break;
        //     case 'round':
        //         result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'current_review_round')}>
        //         Round
        //         {this.getSortIcon('current_review_round')}
        //         </th>)
        //         break;
        //     case 'actions':
        //         result.push(<th key={type}>Actions</th>);
        //         break;
        //     default: break;
        //     }
        // }
        return (
            <tr>
            {
                result.map((value, index) => {
                return value
                })
            }
            </tr>
        )
    },
    
    renderDataRows: function(types, data, ifCreatingClass, ifViewingFromClass) {//, conceptsMap) {
        var result = [],
            _this = this;
        for (var i = 0; i < types.length; i++) {
            var type = types[i];
            switch(type) {
                case 'schoolName':
                    result.push(<td key={type}>
                    {data.schoolName}
                    </td>);
                    break;
                // case 'lastName':
                //     result.push(<td key={type}>
                //         {data.lastName}
                //     </td>);
                //     break;
                case 'noOfTeachers':
                    result.push(<td key={type}>
                        {data.noOfTeachers}
                    </td>);
                    break;
                // case 'phone':
                //     result.push(<td key={type}>
                //         {data.phone}
                //     </td>);
                //     break;
                case 'dateCreated':
                    result.push(<td key={type}>
                        {data.dateCreated}
                    </td>);
                    break;
                default: break;
            }
        }

        if (ifCreatingClass) {

            result.push(<td key={'_id'}>
            
                <button className="btn btn-success" onClick={this.addStudentToClass.bind(this,data.firstName,data.lastName,data.email,data._id)} key={i}>
                    <i className="fa fa-plus" style={{"paddingRight": "5px"}}></i>
                    <span></span>
                </button>

            </td>);
        
        } else {
        
            // if (ifViewingFromClass) { //if user is looking at this student from the student list displayed for a specific class

            //     result.push(<td key={'_id'}>

                    
            //         {/* <button className="btn btn-success" key={i}>
            //         //TODO: to be added later on once the first version has been uploaded to a private test host for testing
            //             <i className="fa fa-plus" style={{"paddingRight": "5px"}}></i>
            //             <span></span>
            //         </button> */}

            //     </td>);
            
            if (ifViewingFromClass) { //if user is looking at this student from the student list displayed for a specific class

                result.push(<td key={'_id'} className='action'>
                
                    <div key={i} className="dp-inline-block viewStudentButton">
                    <Link to={"/student/" + data._id}><button className="btn btn-success"><i className="fa fa-eye"></i>View</button></Link>
                    </div>
                    <div key={i + 'edit'} className="dp-inline-block editStudentButton">
                    <Link to={"/student/edit/" + data._id}><button className="btn btn-success primary"><i className="fa fa-edit"></i>Edit</button></Link>
                    </div>

                </td>);

            } else {

                result.push(<td key={'_id'} className='action'>
                
                    <div key={i} className="dp-inline-block viewStudentButton">
                    <Link to={"/school/" + data._id}><button className="btn btn-success"><i className="fa fa-eye"></i>View</button></Link>
                    </div>
                    <div key={i + 'edit'} className="dp-inline-block editStudentButton">
                    <Link to={"/school/edit/" + data._id}><button className="btn btn-success primary"><i className="fa fa-edit"></i>Edit</button></Link>
                    </div>

                    <div className="dp-inline-block">
                        <button
                            value="Delete"
                            onClick={this.deleteStudent.bind(this,data._id)}
                            className="deleteStudentButton"
                        >DELETE</button>
                    </div>

                </td>);
            }

            //for student analytics-------------------------------
            // result.push(<td key={'_id' + 'email'} className='action'>
                
            //     <div key={i + 'activityHistory'} className="dp-inline-block viewStudentButton" title="Activity History">
            //     <Link to={"/student/activity/" + data._id}><i className="fa fa-activityHistory"></i></Link>
            //     </div>
            //     <div key={i + 'conceptMap'} className="dp-inline-block editStudentButton" title="Concept Map">
            //     <Link to={"/student/conceptmap/" + data._id}><i className="fa fa-conceptMap"></i></Link>
            //     </div>
            //     <div key={i + 'mistakesBank'} className="dp-inline-block editStudentButton" title="Mistakes Bank">
            //     <Link to={"/student/mistakesbank/" + data._id}><i className="fa fa-mistakesBank"></i></Link>
            //     </div>
            //     <div key={i + 'statistics'} className="dp-inline-block editStudentButton" title="Statistics">
            //     <Link to={"/student/statistics/" + data._id}><i className="fa fa-statistics"></i></Link>
            //     </div>
            //     {/* <div className="dp-inline-block">
            //         <button
            //             value="Delete"
            //             onClick={this.deleteStudent.bind(this,data._id)}
            //             className="deleteStudentButton"
            //         ></button>
            //     </div> */}

            // </td>);
            //-------------------------------------------------------------------
            // }
        }

        return (
            <tr key={data._id}>
            {
              result.map((data, index) => {
                return data;
              })
            }
            </tr>
        )
    },

    deleteStudent: function(_id) {
        this.props.deleteStudent(_id);
    },

    addStudentToClass: function(firstName,lastName,email,_id) {

        this.props.addStudentToClass(firstName,lastName,email,_id);
    },

    getSortIcon: function(currentSort) {

        var ascSortIcon = <span className="fa fa-caret-up padding-left-5"></span>,
        descSortIcon = <span className="fa fa-caret-down padding-left-5"></span>,
        sortIcon = <span className="fa fa-sort padding-left-5"></span>,
        sort = this.state.sort;

        if (sort.indexOf(currentSort) >= 0) {
            
            if (sort.charAt(0) === '-') return descSortIcon;
            else return ascSortIcon;
        
        } else {
        
            return sortIcon;
        }
    },

    changeSort: function(chosenSort) {

        var newSort;
        if (this.state.sort.indexOf(chosenSort) >= 0) {
            var sort = this.state.sort;
            
            if (sort.charAt(0) === '-') newSort = sort.substr(1, sort.length);
            else newSort = '-'  + sort;
        
        } else {

            newSort = '-' + chosenSort;
        }

        if (this.props.onSortChange && typeof this.props.onSortChange === 'function') {
            this.props.onSortChange(newSort);
        }
    },

    getInitialState: function() {
        return {
            data: this.props.data,
            // conceptsMap: this.props.conceptsMap,
            // isOpenAssignDialog: false,
            // listReviewers: [],
            // isLoadingReviewers: false,
            // isAssigning: false,
            // assignedCollection: null,
            // assignedReviewers: [],
            // removedReviewers: [],
            mode: this.props.mode,
            sort: this.props.sort,
            ifCreatingClass: this.props.ifCreatingClass,
            ifViewingFromClass: this.props.ifViewingFromClass
        };
    },
    
    componentWillReceiveProps: function(nextProps) {
        this.setState({
          data: nextProps.data || this.state.data,
        //   conceptsMap: nextProps.conceptsMap || this.state.conceptsMap,
        //   mode: nextProps.mode || this.state.mode,
        //   sort: nextProps.sort || this.state.sort
        })
    },

    render: function() {
        var _this = this;
        // const actions = [
        //     <FlatButton
        //         label="Cancel"
        //         primary={true}
        //         onTouchTap={this.closeAssignTaskModal}
        //     />,
        //     <RaisedButton
        //         label={this.state.assignType === 'assign' ? "Assign" : "Re-assign"}
        //         primary={true}
        //         onClick={this.doAssign}/>
        // ];
        return (
            <div className="collection-table">
                
                <table className="table table-bordered table-striped">
                    <thead>
                    {
                        _this.renderHeaderRows(_this.state.ifCreatingClass,_this.state.ifViewingFromClass)//(this.state.mode.cols)
                    }
                    </thead>
                    <tbody>
                        {
                            _this.state.data.map(function(data, index) {
                                {/*if (_this.state.mode.value.indexOf(data.status) < 0) return null;*/}
                                return (
                                    _this.renderDataRows(_this.state.mode.cols, data, _this.state.ifCreatingClass, _this.state.ifViewingFromClass) //_this.state.conceptsMap)
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    },

    componentDidMount: function() {

    }
});

module.exports = SchoolsTable;




/** WEBPACK FOOTER **
 ** ./src/components/Schools/SchoolsTable.js
 **/